import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Col, Row } from "antd";
import { get, includes } from "lodash";
import { setLoading } from "../../../../../redux/ducks/Loading";
import Wbs from "../../../../../services/api/Wbs";
import { showError } from "../../../../../utils/utilities";
import { CheckOutlined } from "@ant-design/icons";
import ProjectTask from "../../../../../services/api/ProjectTask";
import { useParams } from "react-router-dom";

const WbsStructure = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const [state, setState] = useState({
    wbsList: [],
    categoryArr: [],
    wbsCategoryList: [],
    projectWBS: [],
    loading: false,
  });
  useEffect(() => {
    wbsStructureList();
    wbsCheck();
  }, []);

  const wbsStructureList = async () => {
    dispatch(setLoading(true));
    const wbslist = await Wbs.getWbsStructureList("allPages=true&active=true");
    let categorySet = new Set();
    if (!wbslist.error) {
      wbslist.data.forEach((item) => categorySet.add(item.category.name));
      const categoryArr = Array.from(categorySet);
      setState((prevState) => ({
        ...prevState,
        categoryArr,
        wbsCategoryList: wbslist.data,
      }));
    } else {
      showError(get(wbslist, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  const wbsCheck = async () => {
    dispatch(setLoading(true));
    const wbs = await ProjectTask.getProjectTasksAndPhasesOfProject(`id=${params.id}&allPages=true&active=true`);
    if (!wbs.error) {
      const projectWBS = [];
      wbs.data.forEach((item) => {
        projectWBS.push(item.wbsId);
      });
      setState((prevState) => ({
        ...prevState,
        projectWBS,
      }));
    } else {
      showError(get(wbs, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  return (
    <>
      <Row gutter={8}>
        {state.categoryArr.map((categoryName) => {
          return (
            <Col key={categoryName} lg={8} md={24}>
              <Row type="flex" justify="start" className="mt-1em">
                <label className="fw-bold">{categoryName}</label>
              </Row>
              {state.wbsCategoryList.map((wbsI) => {
                return (
                  <Row key={wbsI.id}>
                    {categoryName === wbsI.category.name && (
                      <Row className="mt-10">
                        <Col>
                          <div className="boxValueCheck">
                            {includes(state.projectWBS, wbsI.id) ? <CheckOutlined /> : ""}
                          </div>
                        </Col>
                        <Col className="ml-10">
                          <label>{wbsI.name}</label>
                        </Col>
                      </Row>
                    )}
                  </Row>
                );
              })}
            </Col>
          );
        })}
      </Row>
    </>
  );
};
export default WbsStructure;
